export type Term = {
  singular: string;
  plural: string;
  acronym: string;
};

export const TerminologyOptions = {
  repairOrderNumber: "repairOrderNumber",
  repairOrder: "repairOrder",
  serviceAdvisor: "serviceAdvisor",
  technician: "technician",
  vehicle: "vehicle",
} as const;

export type TerminologyOptions =
  (typeof TerminologyOptions)[keyof typeof TerminologyOptions];

export type Terminology = Record<TerminologyOptions, Term>;

export const TerminologyLabels: Record<TerminologyOptions, string> = {
  [TerminologyOptions.repairOrder]: "Repair Order",
  [TerminologyOptions.repairOrderNumber]: "Repair Order Number",
  [TerminologyOptions.serviceAdvisor]: "Service Advisor",
  [TerminologyOptions.technician]: "Technician",
  [TerminologyOptions.vehicle]: "Vehicle",
} as const;
